import { GET_ACTIVE_ORDER, GET_ORDER_BY_CODDE } from "@/graphql/queries/order"
import { authenticatedRequest } from "@/lib/auth"

export const fetchActiveOrder = async () => {
  const { activeOrder } = await authenticatedRequest(GET_ACTIVE_ORDER)

  return activeOrder
}

export const getOrderByCode = async (orderCode: string) => {
  const { orderByCode } = await authenticatedRequest(GET_ORDER_BY_CODDE, {
    code: orderCode,
  })

  return orderByCode
}
